export default __webpack_public_path__ + "static/media/underline.89fbaea2.svg";